// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Inbox Viewer Page Styles - Simple, clean PDF viewer */
.inbox-viewer-page {
  min-height: 100vh;
  min-height: -webkit-fill-available;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  touch-action: manipulation;
  -webkit-text-size-adjust: 100%;
}

/* Disable text selection and dragging */
.inbox-viewer-page * {
  -webkit-user-drag: none;
  user-drag: none;
}

/* Simple Header */
.inbox-viewer-header {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  z-index: 10;
  flex-shrink: 0;
}

.inbox-viewer-header-left {
  display: flex;
  align-items: center;
  gap: 20px;
  flex: 1 1;
  min-width: 0;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 18px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.back-button:hover {
  background: #f8fafc;
  border-color: #22c55e;
  color: #22c55e;
}

.message-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.message-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Simple Toolbar - Centered page navigation */
.pdf-toolbar {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 14px 24px;
  background: white;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.pdf-toolbar-center {
  display: flex;
  align-items: center;
  gap: 12px;
}

.toolbar-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #475569;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.toolbar-btn:hover:not(:disabled) {
  background: #22c55e;
  border-color: #22c55e;
  color: white;
}

.toolbar-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.page-info {
  color: #1e293b;
  font-size: 1rem;
  font-weight: 500;
  min-width: 80px;
  text-align: center;
  background: #f8fafc;
  padding: 10px 20px;
  border-radius: 8px;
}

/* PDF Container */
.pdf-container {
  flex: 1 1;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 24px;
  background: #f1f5f9;
  -webkit-overflow-scrolling: touch;
}

.pdf-canvas {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  background: white;
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

/* PDF Loading */
.pdf-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 60px;
}

.pdf-loading .loading-spinner {
  width: 48px;
  height: 48px;
  border: 3px solid rgba(34, 197, 94, 0.2);
  border-top-color: #22c55e;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.pdf-loading p {
  color: #64748b;
  font-size: 1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Security overlay */
.security-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 1000;
  background: transparent;
}

/* Error page */
.inbox-viewer-error {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  padding: 20px;
}

.error-content {
  text-align: center;
  padding: 48px;
  background: white;
  border-radius: 16px;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.error-content .error-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: #fef2f2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
  color: #ef4444;
}

.error-content h2 {
  color: #1e293b;
  margin-bottom: 8px;
  font-size: 1.5rem;
}

.error-content p {
  color: #64748b;
  margin-bottom: 28px;
  line-height: 1.6;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  background: #22c55e;
  color: white;
  text-decoration: none;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.back-link:hover {
  background: #16a34a;
}

/* Responsive */
@media (max-width: 640px) {
  .inbox-viewer-header {
    padding: 14px 16px;
  }

  .inbox-viewer-header-left {
    gap: 12px;
  }

  .back-button {
    padding: 8px 14px;
    font-size: 0.9rem;
  }

  .message-title {
    font-size: 1.1rem;
  }

  .pdf-toolbar {
    padding: 12px 16px;
  }

  .toolbar-btn {
    width: 36px;
    height: 36px;
  }

  .page-info {
    font-size: 0.9rem;
    min-width: 70px;
    padding: 8px 14px;
  }

  .pdf-container {
    padding: 16px;
  }

  .error-content {
    padding: 32px 24px;
  }
}

/* Fix for iOS Safari 100vh issue */
@supports (-webkit-touch-callout: none) {
  .inbox-viewer-page {
    min-height: -webkit-fill-available;
  }
}

/* Print protection */
@media print {
  .inbox-viewer-page {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/InboxViewerPage.css"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Inbox Viewer Page Styles - Simple, clean PDF viewer */\n.inbox-viewer-page {\n  min-height: 100vh;\n  min-height: -webkit-fill-available;\n  background: #f8fafc;\n  display: flex;\n  flex-direction: column;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  touch-action: manipulation;\n  -webkit-text-size-adjust: 100%;\n}\n\n/* Disable text selection and dragging */\n.inbox-viewer-page * {\n  -webkit-user-drag: none;\n  user-drag: none;\n}\n\n/* Simple Header */\n.inbox-viewer-header {\n  display: flex;\n  align-items: center;\n  padding: 16px 24px;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  z-index: 10;\n  flex-shrink: 0;\n}\n\n.inbox-viewer-header-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex: 1;\n  min-width: 0;\n}\n\n.back-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 18px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #475569;\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.back-button:hover {\n  background: #f8fafc;\n  border-color: #22c55e;\n  color: #22c55e;\n}\n\n.message-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.message-title {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Simple Toolbar - Centered page navigation */\n.pdf-toolbar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 14px 24px;\n  background: white;\n  border-bottom: 1px solid #e2e8f0;\n  flex-shrink: 0;\n}\n\n.pdf-toolbar-center {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.toolbar-btn {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #475569;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.toolbar-btn:hover:not(:disabled) {\n  background: #22c55e;\n  border-color: #22c55e;\n  color: white;\n}\n\n.toolbar-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.page-info {\n  color: #1e293b;\n  font-size: 1rem;\n  font-weight: 500;\n  min-width: 80px;\n  text-align: center;\n  background: #f8fafc;\n  padding: 10px 20px;\n  border-radius: 8px;\n}\n\n/* PDF Container */\n.pdf-container {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 24px;\n  background: #f1f5f9;\n  -webkit-overflow-scrolling: touch;\n}\n\n.pdf-canvas {\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  background: white;\n  max-width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n/* PDF Loading */\n.pdf-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 60px;\n}\n\n.pdf-loading .loading-spinner {\n  width: 48px;\n  height: 48px;\n  border: 3px solid rgba(34, 197, 94, 0.2);\n  border-top-color: #22c55e;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n.pdf-loading p {\n  color: #64748b;\n  font-size: 1rem;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n/* Security overlay */\n.security-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  z-index: 1000;\n  background: transparent;\n}\n\n/* Error page */\n.inbox-viewer-error {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8fafc;\n  padding: 20px;\n}\n\n.error-content {\n  text-align: center;\n  padding: 48px;\n  background: white;\n  border-radius: 16px;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n}\n\n.error-content .error-icon {\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n  background: #fef2f2;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ef4444;\n}\n\n.error-content h2 {\n  color: #1e293b;\n  margin-bottom: 8px;\n  font-size: 1.5rem;\n}\n\n.error-content p {\n  color: #64748b;\n  margin-bottom: 28px;\n  line-height: 1.6;\n}\n\n.back-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 14px 28px;\n  background: #22c55e;\n  color: white;\n  text-decoration: none;\n  border-radius: 10px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n}\n\n.back-link:hover {\n  background: #16a34a;\n}\n\n/* Responsive */\n@media (max-width: 640px) {\n  .inbox-viewer-header {\n    padding: 14px 16px;\n  }\n\n  .inbox-viewer-header-left {\n    gap: 12px;\n  }\n\n  .back-button {\n    padding: 8px 14px;\n    font-size: 0.9rem;\n  }\n\n  .message-title {\n    font-size: 1.1rem;\n  }\n\n  .pdf-toolbar {\n    padding: 12px 16px;\n  }\n\n  .toolbar-btn {\n    width: 36px;\n    height: 36px;\n  }\n\n  .page-info {\n    font-size: 0.9rem;\n    min-width: 70px;\n    padding: 8px 14px;\n  }\n\n  .pdf-container {\n    padding: 16px;\n  }\n\n  .error-content {\n    padding: 32px 24px;\n  }\n}\n\n/* Fix for iOS Safari 100vh issue */\n@supports (-webkit-touch-callout: none) {\n  .inbox-viewer-page {\n    min-height: -webkit-fill-available;\n  }\n}\n\n/* Print protection */\n@media print {\n  .inbox-viewer-page {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
